const indexItems = [
  { label: '热血战斗', icon: 'ri-sword-line', count: '320部', href: '#cards' },
  { label: '恋爱喜剧', icon: 'ri-heart-line', count: '215部', href: '#cards' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '148部', href: '#cards' },
  { label: '异世界穿越', icon: 'ri-earth-line', count: '186部', href: '#ranking' },
  { label: '治愈日常', icon: 'ri-cup-line', count: '163部', href: '#media' },
  { label: '科幻机甲', icon: 'ri-rocket-line', count: '97部', href: '#cards' },
  { label: '古风国漫', icon: 'ri-brush-line', count: '112部', href: '#cards' },
  { label: '运动竞技', icon: 'ri-basketball-line', count: '85部', href: '#cards' },
  { label: '剧场版', icon: 'ri-film-line', count: '64部', href: '#media' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">动漫索引</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">按分类快速找到你想看的动漫番剧</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="group flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-200 hover:border-primary-200 hover:bg-primary-50/50 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-lg md:text-xl`} style={{ width: '1em', height: '1em' }}></i>
              </div>
              <div className="flex-1 min-w-0">
                <span className="block text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.label}</span>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors" style={{ width: '1em', height: '1em' }}></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}